import { DateDisplay } from "../../../../../../commonComponents/inline/dateDisplay/dateDisplay";
import { ArticleExtraData } from "../../../../../../../articlePage/stateInterfaces";
import { getTranslation } from "../../../../autoTickerRowWidget/autoTickerRowTranslations";
import { minutesDiff } from "../../newsFlashAndTwentyFourSevenMobileComponenta";
import { getImageUrl } from "config/apiUrls";
import { NewsFlashShareMenu } from "../newsFlashShareMenu";
import { isWcmEditor } from "../../../../../../../config/serverConfig";

interface NewsFlashSpecialMobileSlotItemProps {
    index?: number
    isLTR: boolean
    article: ArticleExtraData
    nextRoof: string
    languageCode: string
    previousRoof: string
    roofOngoingEvent: boolean
    openedItemId?: string // used by row item
    onRowItemToggle?: (articleId: string) => void // used by row item
    isFirstInterval?: boolean
    tickerBottomLink?: string
    tickerBottomTitle?: string
    accordionOpenState?: boolean
    highlightingDuration?: number
    openMediaDisplayView?: (videoIndex: number) => void
    handleCarouselAutoplay?: (shouldCarouselAutoplay: boolean) => void
}

interface NewsFlashSpecialMobileSlotItemState {
    isExpandOpen: boolean
    shouldDisplayArticle: boolean
    isFirstRender: boolean
}

const mediaAspectRatios = {
    "6:7": { w: 215, h: 251 },
    "16:9": { w: 448, h: 251 },
    "9:16": { w: 207, h: 370 },
}

export class NewsFlashSpecialSlotItem extends React.Component<NewsFlashSpecialMobileSlotItemProps, NewsFlashSpecialMobileSlotItemState> {

    constructor(props) {
        super(props);
        this.state = {
            isFirstRender: true,
            shouldDisplayArticle: true,
            isExpandOpen: props.accordionOpenState || false,
        }
    }

    componentDidMount() {
        if (this.state.isFirstRender) {
            this.firstRender();
            this.setState({ isFirstRender: false })
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.accordionOpenState !== prevProps.accordionOpenState) {
            this.setState({ isExpandOpen: this.props.accordionOpenState });
        }
    }

    private onSlotClickHandler = (e: React.MouseEvent) => {
        const { article: { title, articleId }, onRowItemToggle } = this.props;
        const { isExpandOpen } = this.state;

        this.dispatchCustomEvent(title);
        if (onRowItemToggle) {
            onRowItemToggle(articleId);
        } else {
            this.setState({ isExpandOpen: !isExpandOpen });
        }
    }

    private dispatchCustomEvent = (title: string) => {
        const { isExpandOpen } = this.state;
        document.dispatchEvent(
            new CustomEvent("newsFlashesTwentyFourSevenReadMoreChange",
                {
                    detail: {
                        action: isExpandOpen ? "Collapse" : "Expand",
                        label: title,
                    }
                }
            ))
    }

    private firstRender = () => {
        const { isFirstInterval, article, highlightingDuration } = this.props;
        const isNow = minutesDiff(article) === 0;
        const isUpToFiveMin = highlightingDuration && minutesDiff(article) < highlightingDuration;

        if (isFirstInterval) {
            isUpToFiveMin && this.setState({ shouldDisplayArticle: false });

            setTimeout(() => {
                this.setState({ shouldDisplayArticle: true })
            }, 3000)
        } else {
            isNow && this.setState({ shouldDisplayArticle: false });

            setTimeout(() => {
                this.setState({ shouldDisplayArticle: true });
            }, 3000)
        }
    }

    private getPosterUrl = () => {
        const { specialData, promotionImageDetails, video } = this.props.article;
        const { mediaLinkType, mediaProportion } = specialData;
        const mediaPosterSize = mediaLinkType !== "none" && mediaLinkType !== undefined && mediaProportion ? mediaAspectRatios[mediaProportion] : { w: 448, h: 251 };

        if (mediaLinkType !== "none" && mediaLinkType !== undefined) {
            if (mediaLinkType === "image") {
                return getImageUrl(promotionImageDetails, mediaPosterSize);
            } else if (mediaLinkType === "video" && video && video[0]) {
                return video[0].posterSrc;
            }
        }
    }

    public render() {
        const { isExpandOpen, shouldDisplayArticle } = this.state;
        const { index, article, languageCode, highlightingDuration, isLTR, nextRoof, previousRoof, roofOngoingEvent, openedItemId, tickerBottomTitle, tickerBottomLink, openMediaDisplayView } = this.props;
        const { articleId, roof, title, dateUpdatedOnSite, plainText, author, specialData, video, publishedLink, promotionImageDetails } = article;
        const { mediaLinkType } = specialData;
        const isRecentItem = highlightingDuration != null && minutesDiff(article) < (highlightingDuration || 1);
        const isItemOpen = openedItemId !== undefined ? openedItemId === articleId : isExpandOpen;
        const isNewItem = highlightingDuration && minutesDiff(article) < highlightingDuration ? "now" : "";
        const isOpen = isItemOpen ? "open" : "";
        const hasRoof = roof && roof.length > 0 ? "has-roof" : "";
        const lang = languageCode ? languageCode.slice(0, 2) : "he";
        const date = isRecentItem ? getTranslation(lang, "Now") : <DateDisplay date={dateUpdatedOnSite} isMinutesAgo={true} isArticle={true} />;
        const isAuthor = author && author.length > 0;
        const mediaId = !isWcmEditor() && mediaLinkType === "video" && video && video[0] && video[0].mediaVideoId ? video[0].mediaVideoId : "";
        const mediaCredit = mediaLinkType === "video" ? video && video[0] && video[0].credit ? video[0].credit : undefined : promotionImageDetails && promotionImageDetails.credit ? promotionImageDetails.credit : undefined;
        // const isFirstRoofInSequence = !roofOngoingEvent ? true : previousRoof !== roof;
        // const shouldShowConnectorLine = roofOngoingEvent && roof && nextRoof === roof;

        if (!shouldDisplayArticle) return null;

        return (
            <div className={`slotView special-flash-item ${isOpen} ${isNewItem} ${hasRoof}`} data_analytics_id={articleId}>
                <div className="slotInfo">
                    {/* {roof && isFirstRoofInSequence &&
                                <div className="roof-sequence-indication">
                                    <div className="dot"></div>
                                    <div className="roof-connector-line" />
                                </div>
                            } */}

                    {mediaLinkType !== "none" && mediaLinkType !== undefined &&
                        <div className="image-container" onClick={() => openMediaDisplayView(index)} data_mediaid_analitycs={mediaId}>
                            <img className="posterImage" src={this.getPosterUrl()} alt={title} />
                            {mediaLinkType === "video" && <div className="video-icon"></div>}
                            {mediaLinkType === "image" && <div className="expand-image-icon"></div>}
                        </div>
                    }

                    <div className="slotInfoText" onClick={this.onSlotClickHandler}>
                        {roof && <span className="roofTitle">{roof}</span>}

                        <div className="slotTitle">{title}</div>

                        {!isOpen && <div className="dateView">{date}</div>}
                    </div>
                </div>

                <div className={`slotContent ${isOpen ? "show" : ""}`} onClick={this.onSlotClickHandler}>
                    <div className="slotText">
                        {plainText}

                        {isAuthor && <div className="author">{`(${author}${mediaCredit ? `, ${mediaCredit}` : ""})`}</div>}

                        <div className="dateView">{date}</div>
                    </div>

                    <div className="share-and-more">
                        <NewsFlashShareMenu
                            title={title}
                            isMobileWeb={true}
                            articleId={articleId}
                            shareUrl={publishedLink}
                            isNew={isNewItem === "now"}
                        />

                        {tickerBottomTitle &&
                            <a className="to-all-flashes-btn" href={tickerBottomLink ? tickerBottomLink : "#"} id="to-all-flashes-btn">
                                <div className="btn-title">{tickerBottomTitle}</div>
                                <div className="btn-arrow"></div>
                            </a>}
                    </div>
                </div>
            </div>
        )
    }
}